<div class="loading-container">
  <mat-spinner diameter="50"></mat-spinner>
  <p class="loading-text">{{ message | translate }}</p>
</div>
